import { render, staticRenderFns } from "./ot-dirty-form-check-wrapper.vue?vue&type=template&id=12c552a5&scoped=true&"
import script from "./ot-dirty-form-check-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-dirty-form-check-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-dirty-form-check-wrapper.vue?vue&type=style&index=0&id=12c552a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c552a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VDivider,VForm})
